import { render } from "./KeyboardF12.vue?vue&type=template&id=7b2980d4"
import script from "./KeyboardF12.vue?vue&type=script&lang=js"
export * from "./KeyboardF12.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF12.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b2980d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b2980d4', __exports__)) {
    api.reload('7b2980d4', __exports__)
  }
  
  module.hot.accept("./KeyboardF12.vue?vue&type=template&id=7b2980d4", () => {
    api.rerender('7b2980d4', render)
  })

}


export default __exports__